import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppVersionCheckResponse, AppVersion } from '../models/core/app-version.model';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {

  constructor(private http: HttpClient) { }


  checkVersion(): Observable<AppVersionCheckResponse> {
    if (!Capacitor.isNativePlatform()) {
      return new Observable(observer => {
        observer.next({
          success: true,
          needs_update: false
        });
        observer.complete();
      });
    }

    const url = `${environment.api_server}/api/app-versions/check`;

    return new Observable(observer => {
      this.getCurrentAppInfo().then(appInfo => {
        const body = {
          platform: appInfo.platform,
          current_version: appInfo.version,
          current_build: appInfo.buildNumber
        };

        this.http.post<AppVersionCheckResponse>(url, body).subscribe({
          next: (response) => observer.next(response),
          error: (error) => observer.error(error)
        });
      }).catch(error => {
        observer.error(error);
      });
    });
  }


  getLatestVersion(): Observable<{ success: boolean, data: AppVersion }> {
    if (!Capacitor.isNativePlatform()) {
      return new Observable(observer => {
        observer.error(new Error('Version check only available on native platforms'));
        observer.complete();
      });
    }

    return new Observable(observer => {
      this.getCurrentAppInfo().then(appInfo => {
        const url = `${environment.api_server}/api/app-versions/latest?platform=${appInfo.platform}`;

        this.http.get<{ success: boolean, data: AppVersion }>(url).subscribe({
          next: (response) => observer.next(response),
          error: (error) => observer.error(error)
        });
      }).catch(error => {
        observer.error(error);
      });
    });
  }


  private async getCurrentAppInfo(): Promise<{ platform: 'ios' | 'android', version: string, buildNumber: string }> {
    const deviceInfo = await Device.getInfo();
    const appInfo = await App.getInfo();

    return {
      platform: deviceInfo.platform === 'ios' ? 'ios' : 'android',
      version: appInfo.version,
      buildNumber: appInfo.build
    };
  }


  async openDownloadUrl(url: string): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
    } else {
      window.open(url, '_blank');
    }
  }
}
